import { render, staticRenderFns } from "./patientItem.vue?vue&type=template&id=26203b26&"
import script from "./patientItem.vue?vue&type=script&lang=js&"
export * from "./patientItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports